module.exports = __webpack_public_path__ + "img/wallet.06b7246e.jpg";